import {Api} from "../api";

export const Files = {

	methods: {
		getOfferPrintUrl (contestId, offerId, moduleId, version) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/offer?contestId=").concat(contestId)
				.concat("&offerId=").concat(offerId);
			if (moduleId) {
				url = url.concat("&moduleId=").concat(moduleId);
			}
			if (version) {
				url = url.concat("&version=").concat(version);
			}
			return url;
		},

		getOfferBudgetPrintUrl (contestId, offerId, moduleId, version) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/offer-budget?contestId=").concat(contestId)
				.concat("&offerId=").concat(offerId);
			if (moduleId) {
				url = url.concat("&moduleId=").concat(moduleId);
			}
			if (version) {
				url = url.concat("&version=").concat(version);
			}
			return url;
		},

		getOfferTimetablePrintUrl (contestId, offerId, moduleId, version) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/offer-timetable?contestId=").concat(contestId)
				.concat("&offerId=").concat(offerId);
			if (moduleId) {
				url = url.concat("&moduleId=").concat(moduleId);
			}
			if (version) {
				url = url.concat("&version=").concat(version);
			}
			return url;
		},

		getOfferActivitiesPrintUrl (contestId, offerId, moduleId, version) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/offer-activities?contestId=").concat(contestId)
				.concat("&offerId=").concat(offerId);
			if (moduleId) {
				url = url.concat("&moduleId=").concat(moduleId);
			}
			if (version) {
				url = url.concat("&version=").concat(version);
			}
			return url;
		},

		getProjectPrintUrl (projectId, version) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/project?projectId=").concat(projectId);
			if (version) {
				url = url.concat("&version=").concat(version);
			}
			return url;
		},

		getProjectBudgetPrintUrl (projectId, version) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/project-budget?projectId=").concat(projectId);
			if (version) {
				url = url.concat("&version=").concat(version);
			}
			return url;
		},

		getProjectTimetablePrintUrl (projectId, version) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/project-timetable?projectId=").concat(projectId);
			if (version) {
				url = url.concat("&version=").concat(version);
			}
			return url;
		},

		getProjectActivitiesPrintUrl (projectId, version) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/project-activities?projectId=").concat(projectId);
			if (version) {
				url = url.concat("&version=").concat(version);
			}
			return url;
		},

		getFinalProtocolPrintUrl (contestId) {
			return process.env.VUE_APP_API_URL
				.concat("/print/final-protocol?contestId=").concat(contestId);
		},

		getBidderEvaluationPrintUrl (contestId, projectId, evaluationId) {
			return process.env.VUE_APP_API_URL
				.concat("/print/bidder-evaluation?contestId=").concat(contestId)
				.concat("&projectId=").concat(projectId)
				.concat("&evaluationId=").concat(evaluationId);
		},

		getCommitteeEvaluationPrintUrl (contestId, bidderId) {
			return process.env.VUE_APP_API_URL
				.concat("/print/committee-evaluation?contestId=").concat(contestId)
				.concat("&bidderId=").concat(bidderId);
		},

		getEvaluationPrintUrl (contestId, evaluationId, evaluationType) {
			return process.env.VUE_APP_API_URL
				.concat("/print/offer-").concat(evaluationType).concat("-evaluation")
				.concat("?contestId=").concat(contestId)
				.concat("&evaluationId=").concat(evaluationId);
		},

		getReportPrintUrl (projectId, reportType, volunteerReportId) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/").concat(reportType).concat("-report")
				.concat("?projectId=").concat(projectId);
			if (volunteerReportId) {
				url = url.concat("&volunteerReportId=").concat(volunteerReportId);
			}
			return url;
		},

		getFormPrintUrl (contestId, formType, reportId) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/form-preview/").concat(contestId).concat("/").concat(formType);
			if (reportId) {
				url = url.concat("/").concat(reportId);
			}
			return url;
		},

		getAgencyFormPrintUrl (contestId, formType, reportId) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/agency-form-preview/").concat(contestId).concat("/").concat(formType);
			if (reportId) {
				url = url.concat("/").concat(reportId);
			}
			return url;
		},

		getAgencyProjectPrintUrl (agencyContestId, agencyId, projectId, version) {
			let url = process.env.VUE_APP_API_URL
				.concat("/print/agency-project")
				.concat("?agencyContestId=").concat(agencyContestId)
				.concat("&projectId=").concat(projectId)
				.concat("&agencyId=").concat(agencyId);
			if (version) {
				url = url.concat("&version=").concat(version);
			}
			return url;
		},

		getMonitoringPrintUrl(projectId, monitoringId) {
			return process.env.VUE_APP_API_URL
				.concat("/print/monitoring")
				.concat("?projectId=").concat(projectId)
				.concat("&monitoringId=").concat(monitoringId);
		},

		getAgencyMonitoringPrintUrl(projectId, monitoringId) {
			return process.env.VUE_APP_API_URL
				.concat("/print/agency-monitoring")
				.concat("?projectId=").concat(projectId)
				.concat("&monitoringId=").concat(monitoringId);
		},

		getAgencyEvaluationPrintUrl(agencyContestId, evaluationType, evaluationId) {
			return process.env.VUE_APP_API_URL
				.concat("/print/agency-").concat(evaluationType).concat("-evaluation")
				.concat("?agencyContestId=").concat(agencyContestId)
				.concat("&evaluationId=").concat(evaluationId);
		},

		getAgencyProjectFinalReportPrintUrl(agencyContestId, projectId) {
			return process.env.VUE_APP_API_URL
				.concat("/print/agency-final-report")
				.concat("?agencyContestId=").concat(agencyContestId)
				.concat("&projectId=").concat(projectId);
		},

		getSerialWritingsFileUrl (data) {
			return process.env.VUE_APP_API_URL
				.concat("/correspondence/generate-writings")
				.concat("?contestId=").concat(data.contestId)
				.concat("&templateId=").concat(data.templateId)
				.concat("&offerStatusList=").concat(data.offerStatusList)
				.concat("&isHidden=").concat(data.isHidden)
				.concat("&isNotHidden=").concat(data.isNotHidden)
				.concat("&isArchived=").concat(data.isArchived)
				.concat("&isNotArchived=").concat(data.isNotArchived)
				.concat("&isAwaitingAnnexSigning=").concat(data.isAwaitingAnnexSigning)
				.concat("&isNotAwaitingAnnexSigning=").concat(data.isNotAwaitingAnnexSigning);
		},

		getContestFileUrl(contestFileId) {
			return process.env.VUE_APP_API_URL + "/public-contest-document/download?contestDocumentId=" + contestFileId;
		},

		getAgencyContestFileUrl(contestFileId) {
			return process.env.VUE_APP_API_URL + "/agency-contest-document/download?contestDocumentId=" + contestFileId;
		},

		getContractFileUrl(contractTemplateId) {
			return process.env.VUE_APP_API_URL + "/contract/download?contractTemplateId=" + contractTemplateId;
		},

		getDonationContractFileUrl(donationContractTemplateId) {
			return process.env.VUE_APP_API_URL + "/donation-contract/download?templateId=" + donationContractTemplateId;
		},

		getCorrespondenceTemplateFileUrl (correspondenceTemplateId) {
			return process.env.VUE_APP_API_URL + "/correspondence/download?templateId=" + correspondenceTemplateId;
		},

		getAgencyProjectAttachmentUrl (attachmentId) {
			return process.env.VUE_APP_API_URL + "/agency-project-correspondence/download?attachmentId=" + attachmentId;
		},

		getLibraryFileUrl(libraryFileId) {
			return process.env.VUE_APP_API_URL + "/library/download?libraryId=" + libraryFileId;
		},

		getFileUrl (fileHash) {
			return process.env.VUE_APP_API_URL.concat("/file/download-file?fileHash=").concat(fileHash);
		},

		getSignedProjectFile(projectId){
            return process.env.VUE_APP_API_URL.concat("/project/signed-report-file?projectId=").concat(projectId);
        },

		getAgencyProjectSignedProjectFile(projectId){
            return process.env.VUE_APP_API_URL.concat("/agencyProject/signed-report-file?projectId=").concat(projectId);
        },

		generateContract(projectId, contractTemplateId) {
			return process.env.VUE_APP_API_URL.concat("/contract/generate?projectId=").concat(projectId).concat("&templateId=").concat(contractTemplateId);
		},

		generateDonationContract(projectId, contractTemplateId) {
			return process.env.VUE_APP_API_URL.concat("/donation-contract/generate?projectId=").concat(projectId).concat("&templateId=").concat(contractTemplateId);
		},

		generateCorrespondence(projectId, templateId) {
			return process.env.VUE_APP_API_URL.concat("/correspondence/generate?projectId=").concat(projectId).concat("&templateId=").concat(templateId);
		},

		getProjectAgreement(projectId) {
			return process.env.VUE_APP_API_URL.concat("/project/agreement?projectId=").concat(projectId);
		},

		getProjectFile(hash) {
			return process.env.VUE_APP_API_URL.concat("/project/project-file?hash=").concat(hash);
		},

		getProjectDocument(fileId) {
			return process.env.VUE_APP_API_URL.concat("/project/document?fileId=").concat(fileId);
		},

		getMonitoringAttachment(monitoringId, attachmentIndex) {
			return process.env.VUE_APP_API_URL.concat("/monitoring/attachment?monitoringId=" + monitoringId + "&index=" + attachmentIndex);
		},

		getAgencyMonitoringAttachment(agencyMonitoringId, attachmentIndex) {
			return process.env.VUE_APP_API_URL.concat("/agency-monitoring/attachment?agencyMonitoringId=" + agencyMonitoringId + "&index=" + attachmentIndex);
		},

		downloadContestFile(ctx, contestFileId, fileName) {
			this.downloadFileAsBlob(ctx, this.getContestFileUrl(contestFileId), fileName);
		},

		downloadAgencyContestFile(ctx, contestFileId, fileName) {
			this.downloadFileAsBlob(ctx, this.getAgencyContestFileUrl(contestFileId), fileName);
		},

		downloadContractTemplateFile(ctx, contractTemplateId, fileName) {
			this.downloadFileAsBlob(ctx, this.getContractFileUrl(contractTemplateId), fileName);
		},

		downloadDonationContractTemplateFile(ctx, donationContractTemplateId, fileName) {
			this.downloadFileAsBlob(ctx, this.getDonationContractFileUrl(donationContractTemplateId), fileName);
		},

		downloadCorrespondenceTemplateFile(ctx, correspondenceTemplateId, fileName) {
			this.downloadFileAsBlob(ctx, this.getCorrespondenceTemplateFileUrl(correspondenceTemplateId), fileName);
		},

		downloadAgencyProjectAttachment(ctx, attachmentId, fileName) {
			this.downloadFileAsBlob(ctx, this.getAgencyProjectAttachmentUrl(attachmentId), fileName);
		},

		downloadMonitoringAttachment(ctx, monitoringId, attachmentIndex, fileName) {
			this.downloadFileAsBlob(ctx, this.getMonitoringAttachment(monitoringId, attachmentIndex), fileName);
		},

		downloadAgencyMonitoringAttachment(ctx, monitoringId, attachmentIndex, fileName) {
			this.downloadFileAsBlob(ctx, this.getAgencyMonitoringAttachment(monitoringId, attachmentIndex), fileName);
		},

		downloadLibraryFile(ctx, libraryId, fileName) {
			this.downloadFileAsBlob(ctx, this.getLibraryFileUrl(libraryId), fileName);
		},

		downloadBlobResponse(blobResponse, filename) {
			let link = document.createElement("a");
			if (!!window.MSInputMethodContext && !!document.documentMode) {
				window.navigator.msSaveOrOpenBlob(blobResponse, filename);
			} else {
				let binaryData = [];
				binaryData.push(blobResponse);
				link.href = window.URL.createObjectURL(new Blob(binaryData, {type: "application/vnd.ms-excel;charset=UTF-8"}));
				link.download = filename;
				link.click();
			}
		},

		async downloadFileAsBlob(ctx, url, fileName) {
			Api.requestStarted();
			await ctx.$http.get(url, {responseType: 'arraybuffer'}).then(
				response => {
					Api.requestEnded();
					let blob = new Blob([response.data], {type: response.headers.get('content-type')});
					if (!!window.MSInputMethodContext && !!document.documentMode) {
						window.navigator.msSaveOrOpenBlob(blob, fileName);
					} else {
						let link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob);
						link.download = fileName;
						link.click();
					}
				},
				error => {
					Api.requestEnded();
					if (error.status === 403) ctx.$router.push("/forbidden");
				}
			);
		},

		async validateFileSize(context, file) {
			if (file === null) {
				return false;
			}

			let validationStatus = false;
			let path = "/file-size-validator?fileSize=" + file.size;
			await Api.syncGet(context, path, () => {
				validationStatus = true;
			}, response => {
				context.$messagesBus.$emit("error", response.message);
				validationStatus = false;
			});
			return validationStatus;
		},

		async validateFilesSize(context, filesArray) {
			if (filesArray === null) {
				return false;
			} else if (filesArray.length < 1) {
				return false;
			}

			let fileSizeArray = [];
			for (let i = 0; i < filesArray.length; i++) {
				fileSizeArray.push(filesArray[i].size);
			}

			let validationStatus = false;
			let path = "/file-size-validator/multiple-files?fileSizeInBytesArray=" + fileSizeArray;
			await Api.syncGet(context, path, () => {
				validationStatus = true;
			}, response => {
				context.$messagesBus.$emit("error", response.message);
				validationStatus = false;
			});
			return validationStatus;
		},

		clearFileInput(elementId) {
			document.getElementById(elementId).value = "";
		},

		getFileExtension(filename) {
			return "." + filename.split('.').pop();
		}
	},

};
